<template>
    <div>
        <header-section
            title="Discount Rate Comparison"
            set-position="relative"
            :create-button="true"
            set-width="100">
        </header-section>
        <div class="o-content ie p-discount-rate-comparison">

            <page-form></page-form>

            <div v-if="!results.count">
                <hr>

                <p class="a-form-inputs--error" v-if="results.count == 0">
                    <br>
                    There are no results for your criteria
                    <br>
                </p>

                <div v-else>
                    <h2>
                        Your results will appear here once you click compare.
                    </h2>
                </div>
            </div>

            <accordion v-if="results !== false && results.count > 0">
                <average-past-future-losses></average-past-future-losses>
                <total-past-future-losses></total-past-future-losses>
                <all-heads-of-loss v-if="claimType"></all-heads-of-loss>
                <assessments-by-age v-if="claimType === 'fatal_accident_estate' || claimType === 'fatal_accident_dependency'"></assessments-by-age>
            </accordion>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import Accordion from 'components/accordion/Accordion.vue';
    import PageForm from 'pages/discount-rate-comparison/components/PageForm.vue';
    import AllHeadsOfLoss from 'pages/discount-rate-comparison/components/sections/AllHeadsOfLoss.vue';
    import AssessmentsByAge from 'pages/discount-rate-comparison/components/sections/AssessmentsByAge.vue';
    import AveragePastFutureLosses from 'pages/discount-rate-comparison/components/sections/AveragePastFutureLosses.vue';
    import TotalPastFutureLosses from 'pages/discount-rate-comparison/components/sections/TotalPastFutureLosses.vue';
    import HeaderSection from 'components/Header.vue';

    export default {
        name: 'discount-rate-comparison',
        components: {
            Accordion, 
            PageForm,
            AllHeadsOfLoss,
            AssessmentsByAge,
            AveragePastFutureLosses,
            TotalPastFutureLosses,
            HeaderSection
        },
        mounted() {
            this.reset();
        },
        computed: {
            ...mapState('discountRateComparison', [
                'results',
                'claimType',
            ]),
        },
        methods: {
            ...mapActions('discountRateComparison', [
                'reset',
            ]),
        },
    }
</script>



// WEBPACK FOOTER //
// DiscountRateComparison.vue?aa371142